export function topMvSlider() {
  const el = document.querySelector(".js-top-mv-slider");
  if (!el) return;

  // Hide animated elements before Swiper init
  gsap.set(".p-top-slide__logo-01", { visibility: "hidden" });
  gsap.set(".p-top-slide__logo-01 path", { autoAlpha: 0, x: -30 });
  gsap.set(".p-top-slide__logo-02", { visibility: "hidden" });
  gsap.set(".p-top-slide__logo-02 path", { autoAlpha: 0, x: -30 });
  gsap.set(".p-top-slide__logo-03", { visibility: "hidden" });
  gsap.set(".p-top-slide__logo-03 path", { autoAlpha: 0, x: -30 });
  gsap.set(".p-top-slide__logo-04", { visibility: "hidden" });
  gsap.set(".p-top-slide__logo-04 path", { autoAlpha: 0, x: -30 });

  let currentTl = null;

  // スライド切り替え開始時に次スライドのロゴをリセット（ちらつき防止）
  function resetSlideLogos(slide) {
    const trust = slide.querySelector(".p-top-slide__trust");
    if (trust) {
      gsap.set(trust.querySelectorAll("path"), { autoAlpha: 1 });
      gsap.set(trust, { autoAlpha: 1 });
    }
    [
      ".p-top-slide__logo-01",
      ".p-top-slide__logo-02",
      ".p-top-slide__logo-03",
      ".p-top-slide__logo-04",
    ].forEach((sel) => {
      const logo = slide.querySelector(sel);
      if (logo) {
        gsap.set(logo.querySelectorAll("path"), { autoAlpha: 0, x: -30 });
        gsap.set(logo, { visibility: "hidden" });
      }
    });
  }

  function animateSlide01(slide) {
    const trustPaths = slide.querySelectorAll(".p-top-slide__trust path");
    const trust = slide.querySelector(".p-top-slide__trust");
    const logoPaths = slide.querySelectorAll(".p-top-slide__logo-01 path");
    const logo = slide.querySelector(".p-top-slide__logo-01");

    if (!trustPaths.length || !logoPaths.length) return;

    if (currentTl) currentTl.kill();

    // Reset states
    gsap.set(trustPaths, { autoAlpha: 1 });
    gsap.set(trust, { autoAlpha: 1 });
    gsap.set(logoPaths, { autoAlpha: 0, x: -30 });
    gsap.set(logo, { autoAlpha: 1 });

    currentTl = gsap.timeline();

    // trust を左から1文字ずつ消しつつ、logo-01 を左から1文字ずつ表示
    currentTl.to(
      trustPaths,
      {
        autoAlpha: 0,
        duration: 0.45,
        stagger: 0.07,
        ease: "power2.in",
      },
      "+=1.3",
    );

    currentTl.to(
      logoPaths,
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.75,
        stagger: 0.12,
        ease: "power2.out",
      },
      "<",
    );
  }

  function animateSlide02(slide) {
    const logoPaths = slide.querySelectorAll(".p-top-slide__logo-02 path");
    const logo = slide.querySelector(".p-top-slide__logo-02");

    if (!logoPaths.length) return;

    if (currentTl) currentTl.kill();

    // Reset states
    gsap.set(logoPaths, { autoAlpha: 0, x: -30 });
    gsap.set(logo, { autoAlpha: 1 });

    currentTl = gsap.timeline();

    // 1秒後に左から1文字ずつふわっと表示
    currentTl.to(
      logoPaths,
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        stagger: 0.04,
        ease: "power2.out",
      },
      "+=0.0",
    );
  }

  function animateSlide03(slide) {
    const logoPaths = slide.querySelectorAll(".p-top-slide__logo-03 path");
    const logo = slide.querySelector(".p-top-slide__logo-03");

    if (!logoPaths.length) return;

    if (currentTl) currentTl.kill();

    // Reset states
    gsap.set(logoPaths, { autoAlpha: 0, x: -30 });
    gsap.set(logo, { autoAlpha: 1 });

    currentTl = gsap.timeline();

    // 1秒後に左から1文字ずつふわっと表示
    currentTl.to(
      logoPaths,
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        stagger: 0.04,
        ease: "power2.out",
      },
      "+=0.0",
    );
  }

  function animateSlide04(slide) {
    const logoPaths = slide.querySelectorAll(".p-top-slide__logo-04 path");
    const logo = slide.querySelector(".p-top-slide__logo-04");

    if (!logoPaths.length) return;

    if (currentTl) currentTl.kill();

    // Reset states
    gsap.set(logoPaths, { autoAlpha: 0, x: -30 });
    gsap.set(logo, { autoAlpha: 1 });

    currentTl = gsap.timeline();

    // 1秒後に左から1文字ずつふわっと表示
    currentTl.to(
      logoPaths,
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.5,
        stagger: 0.04,
        ease: "power2.out",
      },
      "+=0.0",
    );
  }

  function animateActiveSlide(slide) {
    if (slide.querySelector(".p-top-slide__trust")) {
      animateSlide01(slide);
    } else if (slide.querySelector(".p-top-slide__logo-02")) {
      animateSlide02(slide);
    } else if (slide.querySelector(".p-top-slide__logo-03")) {
      animateSlide03(slide);
    } else if (slide.querySelector(".p-top-slide__logo-04")) {
      animateSlide04(slide);
    }
  }

  const swiper = new Swiper(el, {
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1000,
  });

  // 初回アニメーション
  animateActiveSlide(swiper.slides[swiper.activeIndex]);

  // スライド切り替え完了時
  swiper.on("slideChangeTransitionEnd", () => {
    // 非アクティブスライドのロゴをリセット（次回ループ時のちらつき防止）
    swiper.slides.forEach((slide, index) => {
      if (index !== swiper.activeIndex) {
        resetSlideLogos(slide);
      }
    });
    // アクティブスライドのアニメーション開始
    animateActiveSlide(swiper.slides[swiper.activeIndex]);
  });
}
